
      requestAnimationFrame(() => {
        requestAnimationFrame(() => import('/src/main.jsx'));
      });
    